var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChat = function SvgChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 2.79999H4.4C3.0744 2.79999 2 3.87439 2 5.19999V15.6V16.2624C2 17.6592 3.5792 18.472 4.716 17.66L6.9736 16.0472C7.3808 15.756 7.8688 15.6 8.3688 15.6H15.6C16.9256 15.6 18 14.5256 18 13.2V5.19999C18 3.87439 16.9256 2.79999 15.6 2.79999Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 8.39999H7.60005C7.15765 8.39999 6.80005 8.04159 6.80005 7.59999C6.80005 7.15839 7.15765 6.79999 7.60005 6.79999H12.4C12.8424 6.79999 13.2 7.15839 13.2 7.59999C13.2 8.04159 12.8424 8.39999 12.4 8.39999Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 11.6H7.60005C7.15765 11.6 6.80005 11.2416 6.80005 10.8C6.80005 10.3584 7.15765 10 7.60005 10H10.8C11.2424 10 11.6 10.3584 11.6 10.8C11.6 11.2416 11.2424 11.6 10.8 11.6Z",
    fill: "#C5C5CA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.e7f2e0d3839a64ec1234a5e5f807437f.svg";